import React from 'react';

import OptionItem from './OptionItem';

import scss from './BenchmarksNodeList.module.scss';

function GroupWithNodes({ label, options, selectedOptions, onSelect, search }) {
  if (!options.length) {
    return null;
  }

  return (
    <div className={scss.group}>
      <span className={scss.groupTitle}>{label}</span>
      <ul className={scss.optionsList}>
        {options.map((node) => (
          <OptionItem
            key={node.id}
            option={node}
            selectedOptions={selectedOptions}
            onSelect={onSelect}
            search={search}
          />
        ))}
      </ul>
    </div>
  );
}

export default GroupWithNodes;
